'use client';
import { useSnackbar } from '@/contexts/SnackbarContext';
import { useTranslation } from '@/lib/i18n';
import { copyTable } from '@/lib/utils/copy';
import { CopyIcon } from 'lucide-react';
import { useRef } from 'react';

// Table component with copy functionality
export default function TableWithCopy({ children, ...props }: any) {
  const tableRef = useRef<HTMLTableElement>(null);
  const { showError, showSuccess } = useSnackbar();
  const { t } = useTranslation();

  const handleCopy = () => {
    try {
      copyTable(tableRef);
      showSuccess(t('Table copied successfully'));
    } catch (err) {
      showError(t('Table copying failed'));
    }
  };

  return (
    <div className="w-full my-2 relative">
      {/* Copy button positioned absolutely, not taking up space */}
      <button
        onClick={handleCopy}
        className="absolute -top-7 right-0 flex items-center justify-center z-10 transition-colors size-7.5 rounded-full
          text-[#757575] hover:text-black dark:hover:text-white
          dark:bg-[#2c2c2f] bg-[#E9E9E9]
          "
        title="Copy table data"
      >
        <CopyIcon size={16} />
      </button>
      <div className="w-full overflow-x-auto shadow-xs">
        <table ref={tableRef} className="w-full border-collapse" {...props}>
          {children}
        </table>
      </div>
    </div>
  );
}
